'use strict';

var $ = require('jquery');

module.exports = {
	init: function () {
		var self = this;

		// Listen for ajax requests since they commonly result in DOM changing, and in some instances
		// new chat links being added
		var $document = $(document);
		$document.on('ajaxComplete a4jComplete', function (event, extraData) {
			self.setup();
		});

		this.setup();
	},
	setup: function () {
		var $lhnContainer = $(".liveChat");
		if ($lhnContainer.length) {
			var anchors = $lhnContainer.children("a");
			anchors.off('click.LiveChat');
			anchors.on('click.LiveChat', function (event) {
				event.preventDefault();
				window.lhnJsSdk.openHOC();
			});
		}
	}
}
